import mermaid from 'mermaid';
import { ExportFormat } from '../types';

export class ExportService {
  static async exportMermaid(mermaidCode: string, format: ExportFormat, filename: string): Promise<void> {
    switch (format) {
      case 'mermaid':
        this.downloadText(mermaidCode, `${filename}.mmd`);
        break;
      case 'svg':
        await this.exportSVG(mermaidCode, filename);
        break;
      case 'png':
        await this.exportPNG(mermaidCode, filename);
        break;
      case 'drawio':
        await this.exportDrawIO(mermaidCode, filename);
        break;
    }
  }

  private static async exportSVG(mermaidCode: string, filename: string): Promise<void> {
    const { svg } = await mermaid.render('export-diagram', mermaidCode);
    this.downloadText(svg, `${filename}.svg`);
  }

  private static async exportPNG(mermaidCode: string, filename: string): Promise<void> {
    const { svg } = await mermaid.render('export-diagram', mermaidCode);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    const svgBlob = new Blob([svg], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      canvas.toBlob((blob) => {
        if (blob) {
          this.downloadBlob(blob, `${filename}.png`);
        }
        URL.revokeObjectURL(url);
      });
    };
    
    img.src = url;
  }

  private static async exportDrawIO(mermaidCode: string, filename: string): Promise<void> {
    // Convert Mermaid to Draw.io XML format
    const drawioXML = this.mermaidToDrawIO(mermaidCode);
    this.downloadText(drawioXML, `${filename}.drawio`);
  }

  private static mermaidToDrawIO(mermaidCode: string): string {
    // Basic conversion - creates a Draw.io XML with embedded Mermaid
    const encoded = btoa(unescape(encodeURIComponent(mermaidCode)));
    
    return `<?xml version="1.0" encoding="UTF-8"?>
<mxfile host="app.diagrams.net" modified="${new Date().toISOString()}" agent="ContactFlowsApp" version="1.0">
  <diagram name="Flow" id="flow">
    <mxGraphModel dx="1422" dy="794" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="827" pageHeight="1169" math="0" shadow="0">
      <root>
        <mxCell id="0"/>
        <mxCell id="1" parent="0"/>
        <mxCell id="2" value="${encoded}" style="text;html=1;strokeColor=none;fillColor=none;align=left;verticalAlign=top;whiteSpace=wrap;rounded=0;fontFamily=Courier New;" vertex="1" parent="1">
          <mxGeometry x="40" y="40" width="740" height="1080" as="geometry"/>
        </mxCell>
      </root>
    </mxGraphModel>
  </diagram>
</mxfile>`;
  }

  private static downloadText(content: string, filename: string): void {
    const blob = new Blob([content], { type: 'text/plain' });
    this.downloadBlob(blob, filename);
  }

  private static downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
